<script setup>
  import { ref } from 'vue'
  const tab = ref(0)
  const changeTab = (index) => {
    if (tab.value === index) {
      tab.value = null
    } else {
      tab.value = index
    }
  }
  const scrollContainer = ref(null); // 获取滚动容器的引用
  const hasPrev = ref(false); // 是否可以滚动到上一项
  const hasNext = ref(true); // 是否可以滚动到下一项
  // 检查滚动位置，更新按钮状态
  const handleScroll = () => {
    if (scrollContainer.value) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollContainer.value;
      hasPrev.value = scrollLeft > 0; // 如果 scrollLeft > 0，说明可以滚动到上一项
      hasNext.value = scrollLeft + clientWidth < scrollWidth; // 如果 scrollLeft + clientWidth < scrollWidth，说明可以滚动到下一项
    }
  };
  // 滚动到上一项
  const scrollPrev = () => {
    if (scrollContainer.value) {
      scrollContainer.value.scrollBy({
        left: -scrollContainer.value.clientWidth, // 向左滚动一个容器的宽度
        behavior: 'smooth', // 平滑滚动
      });
    }
  };

  // 滚动到下一项
  const scrollNext = () => {
    if (scrollContainer.value) {
      scrollContainer.value.scrollBy({
        left: scrollContainer.value.clientWidth, // 向右滚动一个容器的宽度
        behavior: 'smooth', // 平滑滚动
      });
    }
  };
</script>
<template>
  <div
    class="bg-white sticky top-[--nf-navbar-height-m] z-[11] mt-[--nf-navbar-height-m] xl:top-[--nf-navbar-height-d] xl:mt-[--nf-navbar-height-d]"
  >
    <div class="flex h-[60px] items-center justify-between px-4 xl:hidden">
      <div class="relative">
        <button class="flex items-center gap-2 dark:text-white">
          <span class="text-sm font-medium leading-5">Discover</span
          ><span class="block text-lg font-bold group-data-[state=open]:hidden"
            ><img
              alt="Down Arrow"
              loading="lazy"
              width="24"
              height="24"
              decoding="async"
              data-nimg="1"
              class="h-6 w-6 cursor-pointer dark:text-white"
              style="color: transparent"
              src="https://assets.upstox.com/website/images/uplearn/icons/arrow-down.svg"
          /></span>
        </button>
      </div>
      <div class="hidden items-center justify-center gap-2 md:hidden">
        <div
          class="text-sm font-medium text-black dark:text-dark-whites-secondary"
        >
          Course Outline
        </div>
        <img
          alt="course-chapters"
          loading="lazy"
          width="20"
          height="20"
          decoding="async"
          data-nimg="1"
          class="w-6"
          style="color: transparent"
          src="https://assets.upstox.com/website/images/uplearn/icons/vertical-menu.svg"
        />
      </div>
      <div
        class="cursor-pointer whitespace-nowrap py-2 text-sm font-medium text-text-secondary hover:text-primary-base dark:text-dark-whites-secondary md:block"
      >
        My Courses
      </div>
    </div>
  </div>
  <main class="border-solid border-t border-t-blacks-14">
    <div class="custom-background xl:px-0 px-0 md:px-4">
      <div
        class="page-container flex flex-col gap-8 py-8 md:flex-row md:justify-between md:py-12"
      >
        <div
          class="z-[1] flex flex-col self-center text-center md:text-start px-4 md:px-0"
        >
          <h1
            class="px-8 text-3.5xl font-semibold leading-[40px] text-text-primary dark:text-white sm:px-0 sm:text-[41px] md:leading-[52px]"
          >
            Learn&nbsp;to&nbsp;<span
              class="inline-flex h-[calc(theme(fontSize.3xl)*theme(lineHeight.tight))] flex-col overflow-hidden text-brand-happy-purple dark:text-dark-purple-base md:h-[calc(theme(fontSize.4xl)*theme(lineHeight.tight))]"
              ><ul class="block animate-text-slide-2 [&amp;_li]:block">
                <li>Trade</li>
                <li>Invest</li>
                <li aria-hidden="true">Trade</li>
              </ul></span
            >
            <!-- -->like&nbsp;a&nbsp;pro
          </h1>
          <div
            class="mt-2 text-sm font-normal leading-[26px] text-text-secondary dark:text-dark-whites-base sm:text-md"
          >
            Gain practical knowledge with real-world applications, taught by
            industry experts.
          </div>
          <h2
            class="mt-8 text-sm font-medium text-text-secondary dark:text-dark-whites-base sm:mt-9 sm:font-semibold"
          >
            Popular
          </h2>
          <div
            class="mt-2 flex flex-wrap gap-2 text-sm font-semibold text-text-secondary"
          >
            <a
              
              ><div>
                <div
                  class="rounded-full px-4 py-2 dark:border-dark-background-primary-lighter border border-blacks-3 bg-white text-sm dark:bg-dark-purple-cover dark:text-dark-whites-base"
                >
                  Stock Investing
                </div>
              </div></a
            ><a
              
              ><div>
                <div
                  class="rounded-full px-4 py-2 dark:border-dark-background-primary-lighter border border-blacks-3 bg-white text-sm dark:bg-dark-purple-cover dark:text-dark-whites-base"
                >
                  Options Trading
                </div>
              </div></a
            >
          </div>
        </div>
        <div class="z-[1] md:max-w-[384px]">
          <div class="flex flex-col">
            <div
              class="no-scrollbar flex snap-x snap-mandatory scroll-px-0 gap-0 overflow-y-hidden overflow-x-scroll scroll-smooth lg:gap-4 mb-4 pr-4 sm:mb-2 md:pr-0"
            >
              <div
                class="snap-start pl-4 lg:pl-0 pl-4 md:pl-0"
                data-slide-number="1"
                style="
                  scroll-snap-align: start;
                  margin-right: 0;
                  margin-left: 0;
                "
              >
                <a
                  
                  ><div
                    class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer w-[calc(100vw-2rem)] sm:w-[375px]"
                  >
                    <div class="relative">
                      <img
                        alt="Webinar Logo"
                        fetchpriority="high"
                        width="375"
                        height="208"
                        decoding="async"
                        data-nimg="1"
                        class="aspect-video w-full object-cover object-center"
                        style="color: transparent"
                        src="https://assets.upstox.com/content/assets/images/course_image/ccst.webp"
                      />
                    </div>
                    <div
                      class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                    >
                      <div class="flex flex-col gap-4">
                        <div>
                          <h2
                            class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                          >
                            The Complete Course on Stock Trading
                          </h2>
                          <div
                            class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                          >
                            Milan Bavishi
                          </div>
                        </div>
                        <div class="flex items-center gap-2">
                          <img
                            alt="stopwatch"
                            loading="lazy"
                            width="24"
                            height="24"
                            decoding="async"
                            data-nimg="1"
                            class="h-5 w-5"
                            style="color: transparent"
                            src="https://assets.upstox.com/website/images/uplearn/icons/stopwatch.svg"
                          />
                          <p
                            class="text-sm font-medium text-grey-800 dark:text-dark-whites-base"
                          >
                            4<!-- -->
                            Modules |
                            <!-- -->6 hrs+ content
                          </p>
                        </div>
                      </div>
                      <div class="flex justify-between items-end">
                        <div class="w-full self-center">
                          <div class=""></div>
                        </div>
                        <button
                          class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                        >
                          Learn More
                        </button>
                      </div>
                    </div>
                  </div></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-tan-11 dark:bg-dark-purple-hero px-4 xl:px-0 sm:pb-12 pb-4">
      <div
        class="page-container flex flex-wrap justify-between gap-8 rounded-2xl border bg-white px-4 py-4 dark:border-none dark:bg-dark-purple-grey sm:flex-nowrap sm:justify-around sm:py-[26px]"
      >
        <div class="basis-[40%] text-center">
          <span
            class="block text-xl font-semibold text-text-primary dark:text-white sm:text-2xl"
            >2,00,000+</span
          ><span
            class="block text-sm font-normal text-text-secondary dark:text-dark-whites-secondary"
            >Happy Learners</span
          >
        </div>
        <div class="basis-[40%] text-center">
          <span
            class="block text-xl font-semibold text-text-primary dark:text-white sm:text-2xl"
            >50+</span
          ><span
            class="block text-sm font-normal text-text-secondary dark:text-dark-whites-secondary"
            >Webinars &amp; Courses</span
          >
        </div>
        <div class="basis-[40%] text-center">
          <span
            class="block text-xl font-semibold text-text-primary dark:text-white sm:text-2xl"
            >10+</span
          ><span
            class="block text-sm font-normal text-text-secondary dark:text-dark-whites-secondary"
            >Expert Speakers</span
          >
        </div>
        <div class="basis-[40%] text-center">
          <span
            class="block text-xl font-semibold text-text-primary dark:text-white sm:text-2xl"
            >500+</span
          ><span
            class="block text-sm font-normal text-text-secondary dark:text-dark-whites-secondary"
            >Sessions</span
          >
        </div>
      </div>
    </div>
    <a 
      ><div class="bg-tan-11 dark:bg-dark-purple-hero px-4 xl:px-0">
        <div class="page-container py-4 sm:py-12">
          <img
            alt="Subscription Banner"
            fetchpriority="high"
            width="364"
            height="328"
            decoding="async"
            data-nimg="1"
            class="block w-full rounded-md sm:hidden"
            style="color: transparent"
            src="https://assets.upstox.com/website/images/uplearn/subscription-banner-mobile.webp"
          /><img
            alt="Subscription Banner"
            fetchpriority="high"
            width="1174"
            height="304"
            decoding="async"
            data-nimg="1"
            class="hidden rounded-md sm:block"
            style="color: transparent"
            src="https://assets.upstox.com/website/images/uplearn/subscription-banner.webp"
          />
        </div></div
    ></a>
    <div class="bg-tan-11 dark:bg-dark-purple-cover xl:px-0 px-4">
      <div class="page-container overflow-hidden py-8 sm:py-12">
        <section id="courses" class="-mt-36 pt-36">
          <div
            class="flex items-center justify-center gap-6 px-4 md:justify-between lg:px-0"
          >
            <div class="text-center sm:text-start">
              <h2
                class="text-2xl text-[23px] font-semibold text-text-primary dark:text-white sm:text-[32px] sm:leading-[42px]"
              >
                Watch expert courses
              </h2>
              <span
                class="mt-2 text-base font-normal text-text-secondary dark:text-dark-whites-base sm:text-md sm:leading-[26px]"
                >Elevate your skills with per-recorded courses from experts at
                any time from anywhere</span
              >
            </div>
            <a 
              ><button
                class="cursor-pointer text-sm font-semibold disabled:cursor-not-allowed border border-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full hidden whitespace-nowrap bg-white px-[72px] py-3 text-text-primary sm:block"
              >
                Explore all Courses
              </button></a
            >
          </div>
          <div
            class="my-4 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
          >
            <a
              
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/course_image/ccst.webp"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        The Complete Course on Stock Trading
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Milan Bavishi
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <img
                        alt="stopwatch"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="h-5 w-5"
                        style="color: transparent"
                        src="https://assets.upstox.com/website/images/uplearn/icons/stopwatch.svg"
                      />
                      <p
                        class="text-sm font-medium text-grey-800 dark:text-dark-whites-base"
                      >
                        4<!-- -->
                        Modules |
                        <!-- -->6 hrs+ content
                      </p>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/course_image/otba_pre-rec.webp"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Options Trading Course: Basics to Advanced
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Dr. Chirag Shah
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <img
                        alt="stopwatch"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="h-5 w-5"
                        style="color: transparent"
                        src="https://assets.upstox.com/website/images/uplearn/icons/stopwatch.svg"
                      />
                      <p
                        class="text-sm font-medium text-grey-800 dark:text-dark-whites-base"
                      >
                        5<!-- -->
                        Modules |
                        <!-- -->14 hrs+ content
                      </p>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a 
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/course_image/wcta.webp"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Wealth Creation Using Technical Analysis
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Milan Vaishnav
                      </div>
                    </div>
                    <div class="flex items-center gap-2">
                      <img
                        alt="stopwatch"
                        loading="lazy"
                        width="24"
                        height="24"
                        decoding="async"
                        data-nimg="1"
                        class="h-5 w-5"
                        style="color: transparent"
                        src="https://assets.upstox.com/website/images/uplearn/icons/stopwatch.svg"
                      />
                      <p
                        class="text-sm font-medium text-grey-800 dark:text-dark-whites-base"
                      >
                        3<!-- -->
                        Modules |
                        <!-- -->6 hrs+ content
                      </p>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            >
          </div>
          <div class="mt-6 block px-4 text-center sm:hidden lg:px-0">
            <a 
              ><button
                class="cursor-pointer disabled:cursor-not-allowed border border-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full mx-auto bg-white px-6 py-3 text-base font-medium text-text-primary"
              >
                Explore all Courses
              </button></a
            >
          </div>
        </section>
      </div>
    </div>
    <div class="bg-tan-11 dark:bg-dark-purple-hero xl:px-0 px-4">
      <div class="page-container overflow-hidden py-8 sm:py-12">
        <section
          id="upcoming-webinars"
          class="flex items-center justify-between gap-6 px-4 lg:px-0"
        >
          <div class="pb-4 text-center sm:text-start">
            <h2
              class="mb-3 text-2xl font-semibold text-text-primary dark:text-white sm:text-3.5xl"
            >
              Upcoming Webinars
            </h2>
            <span
              class="text-base font-normal text-text-secondary dark:text-dark-whites-secondary sm:text-md sm:font-medium sm:leading-[26px]"
              >Learn directly from Experts • Real-time Doubt Solving • Practical
              Applications</span
            >
          </div>
          <a class="hidden sm:block" 
            ><button
              class="cursor-pointer text-sm disabled:cursor-not-allowed border border-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full whitespace-nowrap bg-white px-[72px] py-3 font-medium text-text-primary"
            >
              Explore all Webinars
            </button></a
          >
        </section>
        <div
          class="no-scrollbar z-[1] flex cursor-pointer overflow-auto text-center text-base font-medium leading-6 mb-6 w-screen gap-4 overflow-x-scroll border-b border-b-grey-200 px-4 text-text-soft dark:border-b-dark-whites-secondary sm:w-auto lg:px-0"
        >
          <div
            class="me-2 px-1 py-2 hover:text-primary-base activeNav border-b-2 border-brand-happy-purple font-semibold text-brand-happy-purple dark:border-dark-purple-base dark:text-dark-purple-base"
          >
            <div class="flex gap-1 whitespace-nowrap">All</div>
          </div>
          <div
            class="me-2 px-1 py-2 hover:text-primary-base text-text-secondary/50 dark:text-dark-whites-secondary"
          >
            <div class="flex gap-1 whitespace-nowrap">Fundamental Analysis</div>
          </div>
          <div
            class="me-2 px-1 py-2 hover:text-primary-base text-text-secondary/50 dark:text-dark-whites-secondary"
          >
            <div class="flex gap-1 whitespace-nowrap">Technical Analysis</div>
          </div>
          <div
            class="me-2 px-1 py-2 hover:text-primary-base text-text-secondary/50 dark:text-dark-whites-secondary"
          >
            <div class="flex gap-1 whitespace-nowrap">Options Trading</div>
          </div>
          <div
            class="me-2 px-1 py-2 hover:text-primary-base text-text-secondary/50 dark:text-dark-whites-secondary"
          >
            <div class="flex gap-1 whitespace-nowrap">Risk Management</div>
          </div>
        </div>
        <div>
          <div class="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            <a
              
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/women-and-the-world-of-stock-market.webp"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Women and the World of Stock Market
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Priyanka Acharya
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 8 | 11 AM - 12 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/business-cycles.webp"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Investing Across Business Cycles
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Jay Mehta
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 11 | 5 PM - 6 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/fibonacci-and-pivot-analysis.webp"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        How to optimise trading with Fibonacci and Pivot
                        Analysis
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Mukta Dhamankar
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 12 | 6 PM - 8 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a 
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/break-free-from-debt_priyanka.webp"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Break Free From Debt Traps
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Priyanka Acharya
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 13 | 5 PM - 6 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a 
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/world-of-index-funds-and-etfs.webp"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Understanding the World of Index Funds &amp; ETFs
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Priyanka Acharya
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 15 | 4 PM - 5 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            ><a 
              ><div
                class="flex h-full flex-col overflow-hidden rounded-2xl border border-blacks-3 dark:border-dark-purple-lighter cursor-pointer"
              >
                <div class="relative">
                  <img
                    alt="Webinar Logo"
                    fetchpriority="high"
                    width="375"
                    height="208"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full object-cover object-center"
                    src="https://assets.upstox.com/content/assets/images/course_image/chirag-shah-6-(3).png"
                    style="color: transparent"
                  />
                </div>
                <div
                  class="flex h-full flex-col justify-between gap-8 bg-white p-4 dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex flex-col gap-4">
                    <div>
                      <h2
                        class="text-base font-semibold leading-6 text-blacks-2 dark:text-dark-whites-base sm:text-xl"
                      >
                        Introduction to Fundamental Analysis
                      </h2>
                      <div
                        class="text-sm font-medium text-text-soft dark:text-dark-whites-secondary sm:text-base"
                      >
                        Jay Mehta
                      </div>
                    </div>
                    <div class="flex flex-col gap-2">
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M10.2083 6.5H8.95834C8.88931 6.5 8.83334 6.55596 8.83334 6.625V7.875C8.83334 7.94404 8.88931 8 8.95834 8H10.2083C10.2774 8 10.3333 7.94404 10.3333 7.875V6.625C10.3333 6.55596 10.2774 6.5 10.2083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 6.5H11.4583C11.3893 6.5 11.3333 6.55596 11.3333 6.625V7.875C11.3333 7.94404 11.3893 8 11.4583 8H12.7083C12.7774 8 12.8333 7.94404 12.8333 7.875V6.625C12.8333 6.55596 12.7774 6.5 12.7083 6.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 9H8.95834C8.88931 9 8.83334 9.05596 8.83334 9.125V10.375C8.83334 10.444 8.88931 10.5 8.95834 10.5H10.2083C10.2774 10.5 10.3333 10.444 10.3333 10.375V9.125C10.3333 9.05596 10.2774 9 10.2083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M12.7083 9H11.4583C11.3893 9 11.3333 9.05596 11.3333 9.125V10.375C11.3333 10.444 11.3893 10.5 11.4583 10.5H12.7083C12.7774 10.5 12.8333 10.444 12.8333 10.375V9.125C12.8333 9.05596 12.7774 9 12.7083 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 9H3.95834C3.88931 9 3.83334 9.05596 3.83334 9.125V10.375C3.83334 10.444 3.88931 10.5 3.95834 10.5H5.20834C5.27738 10.5 5.33334 10.444 5.33334 10.375V9.125C5.33334 9.05596 5.27738 9 5.20834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 9H6.45834C6.38931 9 6.33334 9.05596 6.33334 9.125V10.375C6.33334 10.444 6.38931 10.5 6.45834 10.5H7.70834C7.77738 10.5 7.83334 10.444 7.83334 10.375V9.125C7.83334 9.05596 7.77738 9 7.70834 9Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M5.20834 11.5H3.95834C3.88931 11.5 3.83334 11.556 3.83334 11.625V12.875C3.83334 12.944 3.88931 13 3.95834 13H5.20834C5.27738 13 5.33334 12.944 5.33334 12.875V11.625C5.33334 11.556 5.27738 11.5 5.20834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M7.70834 11.5H6.45834C6.38931 11.5 6.33334 11.556 6.33334 11.625V12.875C6.33334 12.944 6.38931 13 6.45834 13H7.70834C7.77738 13 7.83334 12.944 7.83334 12.875V11.625C7.83334 11.556 7.77738 11.5 7.70834 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M10.2083 11.5H8.95834C8.88931 11.5 8.83334 11.556 8.83334 11.625V12.875C8.83334 12.944 8.88931 13 8.95834 13H10.2083C10.2774 13 10.3333 12.944 10.3333 12.875V11.625C10.3333 11.556 10.2774 11.5 10.2083 11.5Z"
                            fill="#6A6A6A"
                          ></path>
                          <path
                            d="M14.0476 2.28572H12.6191V1.33334H11.4286V2.28572H5.23811V1.33334H4.04763V2.28572H2.61906C2.36647 2.28572 2.12423 2.38606 1.94563 2.56467C1.76702 2.74328 1.66668 2.98552 1.66668 3.23811V13.7143C1.66668 13.9669 1.76702 14.2091 1.94563 14.3877C2.12423 14.5663 2.36647 14.6667 2.61906 14.6667H14.0476C14.3002 14.6667 14.5425 14.5663 14.7211 14.3877C14.8997 14.2091 15 13.9669 15 13.7143V3.23811C15 2.98552 14.8997 2.74328 14.7211 2.56467C14.5425 2.38606 14.3002 2.28572 14.0476 2.28572ZM13.6905 13.3572H2.9762V5.61906H13.6905V13.3572Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Mar 18 - 19 | 6 PM - 7:30 PM</span
                        >
                      </div>
                      <div class="flex items-center gap-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M8.33334 1C5.57303 1 3.33334 3.01594 3.33334 5.5C3.33334 9.5 8.33334 15 8.33334 15C8.33334 15 13.3333 9.5 13.3333 5.5C13.3333 3.01594 11.0937 1 8.33334 1ZM8.33334 8C7.93778 8 7.5511 7.8827 7.2222 7.66294C6.89331 7.44318 6.63696 7.13082 6.48558 6.76537C6.33421 6.39991 6.2946 5.99778 6.37177 5.60982C6.44894 5.22186 6.63942 4.86549 6.91913 4.58579C7.19883 4.30608 7.5552 4.1156 7.94316 4.03843C8.33113 3.96126 8.73326 4.00087 9.09871 4.15224C9.46416 4.30362 9.77652 4.55996 9.99628 4.88886C10.216 5.21776 10.3333 5.60444 10.3333 6C10.3328 6.53026 10.1219 7.03863 9.74692 7.41357C9.37197 7.78852 8.8636 7.99942 8.33334 8Z"
                            fill="#6A6A6A"
                          ></path></svg
                        ><span
                          class="text-[13px] font-medium text-blacks-2 dark:text-white sm:text-sm"
                          >Zoom Webinar</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="flex justify-between items-end">
                    <div class="w-full self-center"><div class=""></div></div>
                    <button
                      class="cursor-pointer font-semibold disabled:cursor-not-allowed bg-primary-base text-white hover:bg-primary-dark active:bg-primary-dark disabled:bg-primary-base/50 dark:bg-dark-button-primary dark:hover:bg-dark-purple-base rounded-full whitespace-nowrap px-4 py-[10px] text-sm sm:px-6 sm:py-3 sm:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              </div></a
            >
          </div>
        </div>
        <a class="mt-6 block text-center" 
          ><button
            class="cursor-pointer disabled:cursor-not-allowed border border-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full mx-auto block bg-white px-6 py-3 text-base font-medium text-text-primary sm:hidden"
          >
            Explore all Webinars
          </button></a
        >
      </div>
    </div>
    <div class="dark:bg-dark-purple-cover px-4 xl:px-0">
      <div class="page-container flex flex-col gap-8 py-8 sm:gap-12 sm:py-12">
        <h2
          class="self-center text-center text-2xl font-semibold text-text-primary dark:text-white sm:text-3.5xl"
        >
          Why UpLearn with us?
        </h2>
        <div class="flex flex-col justify-between gap-8 md:flex-row">
          <div
            class="relative flex h-[140px] w-full flex-col justify-end gap-2 overflow-hidden rounded-lg px-5 py-4 sm:h-[191px] md:w-[370px]"
            style="background-color: #fae5df"
          >
            <h3
              class="z-[2] w-3/4 whitespace-break-spaces text-xl font-semibold text-text-primary sm:text-2xl md:w-full"
            >
              Structured Curriculum
            </h3>
            <span
              class="z-[2] w-full text-sm text-text-secondary sm:text-base md:max-w-[277px]"
              >Elevate your skills from Novice to Expert with structured
              pathways </span
            ><img
              alt="Structured Curriculum"
              loading="lazy"
              width="127"
              height="77"
              decoding="async"
              data-nimg="1"
              class="absolute right-[0] top-[0] z-[1] scale-[1.1] object-cover object-center w-[127px] h-[77px]"
              style="color: transparent"
              src="https://assets.upstox.com/website/images/uplearn/why-uplearn-1.svg"
            />
          </div>
          <div
            class="relative flex h-[140px] w-full flex-col justify-end gap-2 overflow-hidden rounded-lg px-5 py-4 sm:h-[191px] md:w-[370px]"
            style="background-color: #fdf5e7"
          >
            <h3
              class="z-[2] w-3/4 whitespace-break-spaces text-xl font-semibold text-text-primary sm:text-2xl md:w-full"
            >
              Live Doubt Solving
            </h3>
            <span
              class="z-[2] w-full text-sm text-text-secondary sm:text-base md:max-w-[277px]"
              >Get real time guidance by top experts</span
            ><img
              alt="Live Doubt Solving"
              loading="lazy"
              width="188"
              height="76"
              decoding="async"
              data-nimg="1"
              class="absolute right-[0] top-[0] z-[1] scale-[1.1] object-cover object-center w-[188px] h-[76px]"
              style="color: transparent"
              src="https://assets.upstox.com/website/images/uplearn/why-uplearn-2.svg"
            />
          </div>
          <div
            class="relative flex h-[140px] w-full flex-col justify-end gap-2 overflow-hidden rounded-lg px-5 py-4 sm:h-[191px] md:w-[370px]"
            style="background-color: #d7f2f5"
          >
            <h3
              class="z-[2] w-3/4 whitespace-break-spaces text-xl font-semibold text-text-primary sm:text-2xl md:w-full"
            >
              Easy to understand
            </h3>
            <span
              class="z-[2] w-full text-sm text-text-secondary sm:text-base md:max-w-[277px]"
              >Grasp complex concepts easily without jargons</span
            ><img
              alt="Easy to understand"
              loading="lazy"
              width="123"
              height="77"
              decoding="async"
              data-nimg="1"
              class="absolute right-[0] top-[0] z-[1] scale-[1.1] object-cover object-center w-[123px] h-[77px]"
              style="color: transparent"
              src="https://assets.upstox.com/website/images/uplearn/why-uplearn-3.svg"
            />
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="dark:bg-dark-purple-cover px-4 xl:px-0">
        <div
          class="page-container mx-auto max-w-[960px] py-8 text-center sm:p-12 sm:pb-8"
        >
          <h2
            class="text-2xl font-semibold text-text-primary dark:text-white sm:text-3.5xl"
          >
            Free courses for you
          </h2>
          <span
            class="mt-2 inline-block text-base font-normal text-text-soft dark:text-white"
            >Start your journey towards financial independence with expert
            training</span
          >
        </div>
      </div>
      <div class="app-background px-4 xl:px-0">
        <div class="page-container">
          <div class="grid gap-6 pb-8 sm:pb-12 md:grid-cols-2 lg:grid-cols-3">
            <a
              class="contents"
              
              ><div
                class="flex flex-col justify-between rounded-b-2xl rounded-tl-2xl rounded-tr-2xl border border-t-0 border-blacks-13 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
              >
                <div class="relative">
                  <img
                    alt="Options 101.png"
                    loading="lazy"
                    width="182"
                    height="328"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full rounded-t-2xl object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/logos/options-101.png"
                  />
                  <div class="absolute right-3 top-3">
                    <div
                      class="inter-display rounded-full border border-[#929292] bg-grey-50 px-3 py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-neutral-800 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                    >
                      Beginner
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-white p-4 pb-2 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                  >
                    <div class="flex flex-col gap-2">
                      <div
                        class="text-[23px] font-semibold leading-8 text-neutral-800 dark:text-dark-whites-base"
                      >
                        Basics of Options
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col gap-2 rounded-2xl bg-white p-4 pt-0 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex items-center justify-between gap-4">
                    <div class="flex gap-2">
                      <div
                        class="inter-display rounded-full bg-grey-50 px-2 py-0.5 text-[13px] font-medium uppercase lining-nums tabular-nums leading-5 text-text-primary dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                      >
                        Trading
                      </div>
                      <div
                        class="inter-display py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-text-primary dark:text-dark-whites-base"
                      >
                        24<!-- -->
                        chapters
                      </div>
                    </div>
                    <button
                      class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed border-[1px] border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full text-sm font-medium bg-transparent border-solid"
                    >
                      Start course
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              class="contents"
              
              ><div
                class="flex flex-col justify-between rounded-b-2xl rounded-tl-2xl rounded-tr-2xl border border-t-0 border-blacks-13 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
              >
                <div class="relative">
                  <img
                    alt="Volatility &amp; Greeks.png"
                    loading="lazy"
                    width="182"
                    height="328"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full rounded-t-2xl object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/logos/volatility-and-greeks.png"
                  />
                  <div class="absolute right-3 top-3">
                    <div
                      class="inter-display rounded-full border border-[#929292] bg-grey-50 px-3 py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-neutral-800 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                    >
                      Beginner
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-white p-4 pb-2 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                  >
                    <div class="flex flex-col gap-2">
                      <div
                        class="text-[23px] font-semibold leading-8 text-neutral-800 dark:text-dark-whites-base"
                      >
                        Volatility and The Option Greeks
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col gap-2 rounded-2xl bg-white p-4 pt-0 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex items-center justify-between gap-4">
                    <div class="flex gap-2">
                      <div
                        class="inter-display rounded-full bg-grey-50 px-2 py-0.5 text-[13px] font-medium uppercase lining-nums tabular-nums leading-5 text-text-primary dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                      >
                        Trading
                      </div>
                      <div
                        class="inter-display py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-text-primary dark:text-dark-whites-base"
                      >
                        11<!-- -->
                        chapters
                      </div>
                    </div>
                    <button
                      class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed border-[1px] border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full text-sm font-medium bg-transparent border-solid"
                    >
                      Start course
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              class="contents"
              
              ><div
                class="flex flex-col justify-between rounded-b-2xl rounded-tl-2xl rounded-tr-2xl border border-t-0 border-blacks-13 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
              >
                <div class="relative">
                  <img
                    alt="Options Strategies.png"
                    loading="lazy"
                    width="182"
                    height="328"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full rounded-t-2xl object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/logos/options-strategies.png"
                  />
                  <div class="absolute right-3 top-3">
                    <div
                      class="inter-display rounded-full border border-[#929292] bg-grey-50 px-3 py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-neutral-800 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                    >
                      Beginner
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-white p-4 pb-2 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                  >
                    <div class="flex flex-col gap-2">
                      <div
                        class="text-[23px] font-semibold leading-8 text-neutral-800 dark:text-dark-whites-base"
                      >
                        Option Strategies
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col gap-2 rounded-2xl bg-white p-4 pt-0 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex items-center justify-between gap-4">
                    <div class="flex gap-2">
                      <div
                        class="inter-display rounded-full bg-grey-50 px-2 py-0.5 text-[13px] font-medium uppercase lining-nums tabular-nums leading-5 text-text-primary dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                      >
                        Trading
                      </div>
                      <div
                        class="inter-display py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-text-primary dark:text-dark-whites-base"
                      >
                        19<!-- -->
                        chapters
                      </div>
                    </div>
                    <button
                      class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed border-[1px] border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full text-sm font-medium bg-transparent border-solid"
                    >
                      Start course
                    </button>
                  </div>
                </div>
              </div></a
            ><a
              class="contents"
              
              ><div
                class="flex flex-col justify-between rounded-b-2xl rounded-tl-2xl rounded-tr-2xl border border-t-0 border-blacks-13 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
              >
                <div class="relative">
                  <img
                    alt="traderiskstruccourse.png"
                    loading="lazy"
                    width="182"
                    height="328"
                    decoding="async"
                    data-nimg="1"
                    class="aspect-video w-full rounded-t-2xl object-cover object-center"
                    style="color: transparent"
                    src="https://assets.upstox.com/content/assets/images/logos/traderiskstruccourse.png"
                  />
                  <div class="absolute right-3 top-3">
                    <div
                      class="inter-display rounded-full border border-[#929292] bg-grey-50 px-3 py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-neutral-800 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                    >
                      Beginner
                    </div>
                  </div>
                  <div
                    class="rounded-2xl bg-white p-4 pb-2 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                  >
                    <div class="flex flex-col gap-2">
                      <div
                        class="text-[23px] font-semibold leading-8 text-neutral-800 dark:text-dark-whites-base"
                      >
                        Trade Risk Management
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="flex flex-col gap-2 rounded-2xl bg-white p-4 pt-0 dark:border-dark-purple-lighter dark:bg-dark-purple-cover-secondary"
                >
                  <div class="flex items-center justify-between gap-4">
                    <div class="flex gap-2">
                      <div
                        class="inter-display rounded-full bg-grey-50 px-2 py-0.5 text-[13px] font-medium uppercase lining-nums tabular-nums leading-5 text-text-primary dark:bg-dark-purple-cover-secondary dark:text-dark-whites-base"
                      >
                        Trading
                      </div>
                      <div
                        class="inter-display py-0.5 text-[13px] font-medium lining-nums tabular-nums leading-5 text-text-primary dark:text-dark-whites-base"
                      >
                        17<!-- -->
                        chapters
                      </div>
                    </div>
                    <button
                      class="cursor-pointer px-4 py-2 disabled:cursor-not-allowed border-[1px] border-primary-base text-primary-base hover:bg-primary-light active:bg-primary-light disabled:border-primary-base/50 disabled:bg-white disabled:text-primary-base/50 dark:border-dark-purple-base dark:bg-transparent dark:text-white dark:hover:bg-dark-purple-grey dark:disabled:border-white/50 dark:disabled:text-white/50 rounded-full text-sm font-medium bg-transparent border-solid"
                    >
                      Start course
                    </button>
                  </div>
                </div>
              </div></a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="app-background xl:px-0 px-0 lg:px-4 dark:bg-dark-purple-cover">
      <div class="page-container flex flex-col gap-8 py-8 sm:gap-12 sm:py-12">
        <h2
          class="self-center px-4 text-2xl font-semibold text-text-primary dark:text-white sm:text-3.5xl lg:px-0"
        >
          Learn from the best
        </h2>
        <div class="flex flex-col">
          <div
          @scroll="handleScroll"  ref="scrollContainer"
            class="no-scrollbar flex snap-x snap-mandatory scroll-px-0 gap-0 overflow-y-hidden overflow-x-scroll scroll-smooth lg:gap-4 mb-4 pr-4 sm:mb-8 lg:pr-0"
          >
            <div
              class="snap-start pl-4 lg:pl-0 pl-4 lg:pl-0"
              data-slide-number="1"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Milan Bavishi"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/milan-bavishi.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Milan Bavishi
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >Director - Content, Upstox</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Milan brings two decades of Indian stock market wisdom,
                    with stints at JM Financial and Ernst &amp; Young. His
                    market insights have been featured on ET Now, Mint, Business
                    Standard and major newspapers.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="2"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Dr. Chirag Shah"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/chirag-shah.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Dr. Chirag Shah
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >Phd, Financial Derivatives</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Dr. Chirag is a derivatives expert with over 15 years of
                    experience in trading stocks and commodities. He has
                    conducted workshops for NSE and is a visiting faculty at
                    leading B-Schools.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="3"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Jay Mehta"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/jay.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Jay Mehta
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >Chartered Financial Analyst</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Jay has 10 years of experience in capital markets. His work
                    experience spans different facets of finance – from Equity
                    Research, Treasury Management, Investor Commutation /
                    Relations, Corporate Strategy and Business Finance.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="4"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Mike Akeroyd"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/mike.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Mike Akeroyd
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >VP of Product</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Mike is the VP of Product at Upstox boasting 20 years of
                    trading experience. He previously led a quantitative fund,
                    worked in Product at Amazon and Disney, holds an MBA from
                    UNC, and served as an Army officer in Iraq.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="5"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Mukta Dhamankar"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/mukta.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Mukta Dhamankar
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >Full-time Trader</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Mukta is full-time trader since last 15 years. She believes
                    in disciplined and practical trading, primarily in cash and
                    derivatives using Point &amp; Figure Charts, Candlesticks
                    with RSI, and sector analysis with Relative Strength.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="6"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Milan Vaishnav"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/milan-vaishnav.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Milan Vaishnav
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >CMT &amp; MSTA</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Milan is a capital market professional with experience
                    spanning over two decades. His core expertise includes
                    Portfolio Management Services (PMS) that help his clients
                    with dynamic investment and trading strategies across
                    multiple asset classes.</span
                  >
                </div>
              </div>
            </div>
            <div
              class="snap-start pl-4 lg:pl-0"
              data-slide-number="7"
              style="scroll-snap-align: start; margin-right: 0; margin-left: 0"
            >
              <div
                class="flex h-full w-[calc(100vw-2rem)] flex-row gap-3 rounded-2xl border border-grey-100 p-2 dark:border-dark-purple-lighter sm:w-full sm:min-w-[265px] sm:flex-col sm:gap-4 sm:p-5"
              >
                <img
                  alt="Siddharth Shirodkar"
                  loading="lazy"
                  width="108"
                  height="140"
                  decoding="async"
                  data-nimg="1"
                  class="aspect-square h-[140px] w-[108px] rounded-md object-cover object-center grayscale sm:h-[243px] sm:w-[265px]"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/tutors/siddharth.webp"
                />
                <div class="flex flex-col sm:gap-2">
                  <h3
                    class="text-sm font-semibold text-text-primary dark:text-white sm:text-md"
                  >
                    Siddharth Shirodkar
                  </h3>
                  <span
                    class="text-[10px] font-medium leading-[1rem] text-text-soft dark:text-dark-whites-secondary sm:text-sm"
                    >Full-time Trader</span
                  ><span
                    class="line-clamp-6 text-[10px] font-normal leading-[1rem] text-text-secondary dark:text-dark-whites-base sm:line-clamp-none sm:text-sm sm:font-medium"
                    >Siddharth is a full time positional trader. Trading is his
                    passion and he envisages that through proper guidance,
                    nurturing and facilitating consistent returns, it can become
                    the passion of his students too.</span
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between px-4 lg:px-0">
            <div class="flex gap-4">
              <div @click="scrollPrev" :class="[!hasPrev?'opacity-30 cursor-not-allowed pointer-events-none':'cursor-pointer']"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-grey-100 p-1"
              >
                <img
                  alt="Back"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  class="h-5 w-5 rotate-180 cursor-pointer"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/icons/pirmary-arw-right.svg"
                />
              </div>
              <div @click="scrollNext"
                :class="[!hasNext?'opacity-30 cursor-not-allowed pointer-events-none':'cursor-pointer']"
                class="flex h-10 w-10 items-center justify-center rounded-full bg-grey-100 p-1"
              >
                <img
                  alt="Forward"
                  loading="lazy"
                  width="24"
                  height="24"
                  decoding="async"
                  data-nimg="1"
                  class="h-5 w-5 cursor-pointer"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/icons/pirmary-arw-right.svg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dark:bg-dark-purple-cover px-4 xl:px-0">
      <div
        class="page-container mx-auto max-w-[960px] py-8 text-center sm:py-12"
      >
        <img
          alt="testimonials"
          loading="lazy"
          width="844"
          height="208"
          decoding="async"
          data-nimg="1"
          class="h-[80px] w-full object-cover object-center sm:h-[208px]"
          style="color: transparent"
          src="https://assets.upstox.com/website/images/uplearn/wall-of-love.svg"
        />
        <h2
          class="mt-8 text-2xl font-semibold text-text-primary dark:text-white sm:mt-16 sm:text-3.5xl"
        >
          Our wall of love ❤️
        </h2>
        <div
          class="mt-16 gap-[60px] text-text-primary sm:grid sm:grid-cols-3"
        >
          <div
            class="dark:text-dark-whites-tertiary flex h-full flex-col justify-start text-blacks-19 gap-8 sm:justify-start sm:gap-5"
          >
            <span
              class="text-start text-base font-normal dark:text-white sm:text-xl sm:font-medium"
              >Thank you for the informative session. The information about OI
              for more helpful.</span
            >
            <div class="flex items-center justify-start gap-4">
              <div class="h-[32px] w-[32px rounded-full border">
                <img
                  alt="reviewer"
                  loading="lazy"
                  width="32"
                  height="32"
                  decoding="async"
                  data-nimg="1"
                  class="object-cover object-center"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/male-cartoon.png"
                />
              </div>
              <span
                class="text-base font-bold dark:text-white sm:text-xl sm:font-medium"
                >Akshay D R</span
              >
            </div>
          </div>
          <div
            class="dark:text-dark-whites-tertiary flex h-full flex-col justify-start text-blacks-19 gap-8 sm:justify-start sm:gap-5"
          >
            <span
              class="text-start text-base font-normal dark:text-white sm:text-xl sm:font-medium"
              >Thanks for such a informative classes.Best of all classes till
              now I have taken earlier. Will like to join your classes in the
              future too.</span
            >
            <div class="flex items-center justify-start gap-4">
              <div class="h-[32px] w-[32px rounded-full border">
                <img
                  alt="reviewer"
                  loading="lazy"
                  width="32"
                  height="32"
                  decoding="async"
                  data-nimg="1"
                  class="object-cover object-center"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/male-cartoon.png"
                />
              </div>
              <span
                class="text-base font-bold dark:text-white sm:text-xl sm:font-medium"
                >Jay Pandey</span
              >
            </div>
          </div>
          <div
            class="dark:text-dark-whites-tertiary flex h-full flex-col justify-start text-blacks-19 gap-8 sm:justify-start sm:gap-5"
          >
            <span
              class="text-start text-base font-normal dark:text-white sm:text-xl sm:font-medium"
              >I understood the mistakes done by me in this session... Thank you
              for this session.</span
            >
            <div class="flex items-center justify-start gap-4">
              <div class="h-[32px] w-[32px rounded-full border">
                <img
                  alt="reviewer"
                  loading="lazy"
                  width="32"
                  height="32"
                  decoding="async"
                  data-nimg="1"
                  class="object-cover object-center"
                  style="color: transparent"
                  src="https://assets.upstox.com/website/images/uplearn/male-cartoon.png"
                />
              </div>
              <span
                class="text-base font-bold dark:text-white sm:text-xl sm:font-medium"
                >Akula Rajneesh</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<style scoped lang="scss">
.page-container {
    margin-left: auto;
    margin-right: auto;
    max-width: 1174px;
}
</style>
